<template lang="html">
  <div id="presion" class="container-fluid">
    <div id="formulario-top">
      <div class="row">
        <div class="col-sm-2 col-sm-offset-2 col-xs-8 col-xs-offset-2">
          <date-picker :date="date" :option="option2" @change="desde = $event"></date-picker>
        </div>
        <div class="col-sm-2 col-sm-offset-0 col-xs-8 col-xs-offset-2">
          <date-picker :date="date" :option="option" @change="hasta = $event"></date-picker>
        </div>
        <div class="col-sm-2">
          <select-c name="ducto" id="ducto" :options="ductos" placeholder="DUCTO" @changeSelect="setEstaciones($event)"></select-c>
        </div>
        <div id="check" class=" checkbox col-sm-2">
          <label class="text-uppercase">
            <input id="auto-refresh" type="checkbox" value="true">auto-refrescar</label>
        </div>
      </div>
      <br>
      <br>
      <div class="row">
        <div class="col-sm-2 col-sm-offset-3">
          <select-c name="estaciones" id="estaciones" :options="estaciones" placeholder="ESTACIONES"></select-c>
        </div>

        <div class="col-sm-2">
          <select-c name="separacion" id="separacion" :options="options" placeholder="SEPARACION"></select-c>
        </div>
        <div id="" class="col-sm-2">
          <button class="btn btn-default waves-effect waves-light">
            Buscar
          </button>
        </div>
      </div>

    </div>
    <div id="graficas" class="row">
      <div class="col-md-9 col-xs-12">
        <div class="panel-body" id="app">
          <line-chart id="line" :data="line" xkey="year" ykeys='[ "and", "ios", "win" ]' line-colors='[ "#FF0000", "#36A2EB", "#FFCE56" ]'
            grid="true" grid-text-weight="bold" resize="true">
          </line-chart>
        </div>
      </div>
      <div class="col-md-3 col-xs-12 nomen">
        <h4>Nomenclatura</h4>
        <div class="col-md-3" style="text-align:right;">
          <hr style="background-color:red; height:3px; width:50px; margin-bottom:35px!important; margin-top:15px!important;">
          <hr style="background-color:#36A2EB; height:3px; width:50px; margin-bottom:35px!important; margin-top:15px!important;">
          <hr style="background-color:#FFCE56; height:3px; width:50px; margin-bottom:35px!important; margin-top:15px!important;">
        </div>
        <div class="col-md-9" style="text-align:left;">
          <p class="nomen-p">REP SALAMANCA</p>
          <p class="nomen-p">VS STA ELENA</p>
          <p class="nomen-p">VS STA MONICA</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
  import selectC from 'components/reusable/Select'
  import Raphael from 'raphael/raphael'
  global.Raphael = Raphael
  import {
    LineChart
  } from 'vue-morris'
  import DatePicker from 'vue-datepicker/vue-datepicker-es6.vue'
  export default {
    data() {
      return {
        date: this.$store.state.dpDate,
        option: this.$store.state.dpOpsHasta,
        option2: this.$store.state.dpOpsDesde,
        ductos: [],
        estaciones: [],
        desde: '',
        hasta: '',
        options: {
          op1: {
            value: '2pm',
            name: '2:00 pm'
          },
          op2: {
            value: '2am',
            name: '2:00 am'
          },
          op3: {
            value: 'all',
            name: 'All'
          }
        },
        line: [{
            year: '2013',
            and: 30,
            ios: 10,
            win: 5
          },
          {
            year: '2014',
            and: 20,
            ios: 40,
            win: 15
          },
          {
            year: '2015',
            and: 30,
            ios: 20,
            win: 25
          },
          {
            year: '2016',
            and: 50,
            ios: 30,
            win: 20
          },
        ]
      }
    },
    methods: {
      setEstaciones(e) {
        this.estaciones = this.$store.getters.GET_OP({
          filteredBy: 'sites',
          ducto: document.querySelector(`#${e}`).value
        })
      }
    },
    mounted() {
      this.$store.dispatch('LOAD_OPS')
        .then(resp => {
          this.ductos = this.$store.getters.GET_OP({
            filteredBy: 'section_name'
          })
        })
        .catch(err => {
          console.log(err)
        })
    },
    components: {
      selectC,
      LineChart,
      DatePicker
    }
  }

</script>

<style lang="scss" scoped>
  @import '~varmix';
  .container-fluid {
    margin: 0;
    padding: 0;
  }

  #presion {
    background-color: $bg;
    #formulario-top {
      height: 25vh;
      margin-top: 80px;
      border-bottom: 1px solid $inactive;
    }

    #graficas {
      height: 65vh;
    }

    .btn-default {
      margin-top: 0;
      background-color: $amarilloC;
      &:hover,
      &:active,
      &:focus {
        background-color: $amarilloO !important;
      }
    }
  }

  .nomen {
    height: 100%;
    border-left: 3px solid gray;
    text-align: center;
  }

</style>



// WEBPACK FOOTER //
// Presion.vue?3ce9ef10